import React from 'react';

import styles from './LinkButton.module.css';

export const LBLinkButton = React.forwardRef<
  React.ComponentRef<'button'>,
  React.ComponentPropsWithoutRef<'button'> & {
    leftsection?: React.ReactNode;
    rightsection?: React.ReactNode;
  }
>(({ children, rightsection, leftsection, ...props }, ref) => (
  <button type='button' {...props} ref={ref} className={styles.button}>
    {leftsection && leftsection}
    {children}
    {rightsection && rightsection}
  </button>
));
